import { routes } from "../../../app/routes";

interface BreadcrumbProps {
  showHome: boolean;
  values: { label: string; url: string | null }[];
}

export function generateAppointmentsBreadcrumbs(
  path: string,
): BreadcrumbProps {
  switch (path) {
    case routes.appointments.index:
      return {
        showHome: true,
        values: [{ label: "Appointments", url: null }],
      };

    default:
      return { showHome: false, values: [] };
  }
}

export default generateAppointmentsBreadcrumbs;
